import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../Context Api/AuthContext";
import TextField from "../../Components/UI/Inputs/TextField";
import Password from "../../Components/UI/Inputs/Password";
import Button from "../../Components/UI/Buttons/Button";
import { SVG_USER } from "../../Assets/SVG/svg_util";

const Login = () => {
  const navigate = useNavigate();
  const initialFormState = {
    email: "",
    password: "",
  };

  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState(initialFormState);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();

  const handleInputChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    setError(""); // Clear any previous error messages
    if (!formData.email || !formData.password) {
      setError("Please fill in all required fields.");
      return;
    }
    try {
      setIsLoading(true);
      const credentials = { ...formData };
      await login(credentials);

      // Only clear form data after successful login
      // The navigation to dashboard is handled in the login function
    } catch (err) {
  

      // Don't clear form data on error
      setError(err?.message || "Login failed. Please check your credentials.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreateAccount = () => {
    navigate("/register");
  };

  const { t } = useTranslation();

  return (
    <div className="px-2 w-full h-full pb-20">
      <div className="border-2 border-[#E0F5FD] rounded lg:w-[500px] shadow-md mx-auto">
        <div className="mb-8 text-center">
          <h2 className="text-xl text-[#7DDBFF] mt-5">{t("login.loginto")}</h2>
          <h2 className="text-2xl font-bold text-[#7DDBFF]">
            {t("login.title")}
          </h2>
        </div>
        <div className="flex flex-col !px-[8%] justify-between h-full">
          <form className="text-center space-y-4" onSubmit={handleSubmit}>
            <TextField
              required
              placeholder={t("login.email")}
              name="email"
              onValueChange={handleInputChange}
              value={formData.email}
              icon={<SVG_USER />}
            />
            <div className="text-right ">
              <Password
                required
                placeholder={t("login.password")}
                name="password"
                showPassword={showPassword}
                onValueChange={handleInputChange}
                togglePassword={() => setShowPassword(!showPassword)}
                value={formData.password}
              />
              <div className="text-red-500 text-sm  px-2">{error}</div>
              <Link
                to="/forgot-password"
                className=" text-[#7DDBFF] cursor-pointer text-sm "
              >
                {t("login.forgot_password")}
              </Link>
            </div>

            <Button
              type="small"
              label={isLoading ? t("login.logging_in") : t("login.login")}
              textColor="white"
              backgroundColor="#7DDBFF"
              handler={handleSubmit}
              style={{
                marginTop: "30px",
                borderRadius: "8px",
                paddingLeft: "60px",
                paddingRight: "60px",
              }}
              form_type="submit"
              disabled={isLoading}
            />
          </form>

          <div className="space-y-1 pt-20 pb-8">
            <h2 className="text-[#6F6F6F] font-bold">
              {t("login.notRegistered")}?
            </h2>
            <Button
              type="full"
              label={t("login.createAccount")}
              textColor="white"
              backgroundColor="#7DDBFF"
              handler={handleCreateAccount}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
